export const AUTH_SUCCESS = "AUTH_SUCCESS"
export const AUTH_FAILED = "AUTH_FAILED"
export const AUTH_LOGOUT = "AUTH_LOGOUT"